import { __assign, __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import styles from './SvgIcon.module.css';
export var SvgIcon = function SvgIcon(_a) {
  var _b;

  var color = _a.color,
      size = _a.size,
      style = _a.style,
      children = _a.children,
      rest = __rest(_a, ["color", "size", "style", "children"]);

  return React.createElement("span", __assign({
    className: styles.root,
    style: __assign(__assign({}, style), {
      fontSize: size,
      color: color
    })
  }, rest), React.cloneElement(children, {
    className: cn((_b = {}, _b[styles.icon] = true, _b[styles.iconWithSize] = typeof size !== 'undefined', _b)),
    fill: 'currentColor',
    focusable: 'false'
  }));
};